import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1300Model } from '../kymw1300.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 商品企画マスタ画面　束ね企画情報一覧を取得するサービス
 *
 * @export GetBundleCatalogRoundInfoListService
 * @class GetBundleCatalogRoundInfoListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetBundleCatalogRoundInfoListService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetBundleCatalogRoundInfoListService
   */
  private successFunc: (model: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

   /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof GetBundleCatalogRoundInfoListService
   */
  private vo: {
    mediumType: '',
  };

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBundleCatalogRoundInfoListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.vo.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetBundleCatalogRoundInfoListService
   */
  execute(vo: any, successFunc: (model: any) => void): void {
    this.successFunc = successFunc;
    this.vo = vo;
    this.send('getBundleCatalogRoundInfoList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetBundleCatalogRoundInfoListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
